// What the office must do next on a buyer form booking, for the Pending work card.
export type BookingTask = 'review' | 'create' | 'sign' | 'digitalCopy' | 'advocate';

export const bookingTasks = (args: { formStatus: string; hasBookingFormFile: boolean; signed: boolean; hasDigitalCopy?: boolean; sentToAdvocate?: boolean }): BookingTask[] => {
  if (args.formStatus === 'submitted') return ['review'];
  if (args.formStatus !== 'approved') return [];
  if (!args.signed) return [args.hasBookingFormFile ? 'sign' : 'create'];
  if (!args.hasDigitalCopy) return ['digitalCopy'];
  return args.sentToAdvocate ? [] : ['advocate'];
};

/** Every buyer ticked as signed on this document. */
export const allSigned = (ticks: Record<string, boolean> | undefined, buyerIds: string[]) =>
  buyerIds.length > 0 && buyerIds.every((id) => !!ticks?.[id]);
